import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { accountType } from "../components/params";
import ChartAccountService from "./chart.account.service";
// import store from "../store";
export default class BalanceSheetService extends ChartAccountService {
  namespace = "balance-sheet";
  DOMAIN = 59;
  showLeftBar = false;
  favicon = "Invoice";
  Width = 1300;
}
